import { ArrowLeft, ChevronLeft, X } from "lucide-react";
import {
  DrawerBody,
  DrawerClose,
  DrawerFooter,
  FloatingCloseButton,
  DrawerHeader,
  DrawerIconButton,
  DrawerPanel,
  DrawerTitleGroup,
  Overlay,
} from "./styles.drawer";

/**
 * Right-side overlay drawer. `onBack` shows a back chevron; `footer` is pinned below the scrolling body.
 * `plainBack` swaps the circled chevron + circled close for a bare arrow and X (no borders).
 * `bare` renders only the panel (the children supply their own header/footer) plus a close button
 * floating on the overlay. `layer` overrides the base z-index.
 */
export default function Drawer({
  title,
  onClose,
  onBack,
  footer,
  children,
  scrollable = true,
  overlayDisabled = false,
  bare = false,
  plainBack = false,
  layer,
}) {
  if (bare) {
    return (
      <>
        <Overlay $layer={layer} onClick={overlayDisabled ? undefined : onClose} />
        <FloatingCloseButton type="button" $layer={layer} aria-label="Close" onClick={onClose}>
          <X size={20} />
        </FloatingCloseButton>
        <DrawerPanel $layer={layer} role="dialog" aria-label={title}>
          {children}
        </DrawerPanel>
      </>
    );
  }

  return (
    <>
      <Overlay $layer={layer} onClick={overlayDisabled ? undefined : onClose} />
      <DrawerPanel $layer={layer} role="dialog" aria-label={title}>
        <DrawerHeader>
          <DrawerTitleGroup>
            {onBack ? (
              plainBack ? (
                <DrawerClose type="button" aria-label="Back" onClick={onBack}>
                  <ArrowLeft size={24} />
                </DrawerClose>
              ) : (
                <DrawerIconButton type="button" aria-label="Back" onClick={onBack}>
                  <ChevronLeft size={18} />
                </DrawerIconButton>
              )
            ) : null}
            <span>{title}</span>
          </DrawerTitleGroup>
          {onBack && !plainBack ? (
            <DrawerIconButton type="button" aria-label="Close" onClick={onClose}>
              <X size={16} />
            </DrawerIconButton>
          ) : (
            <DrawerClose type="button" aria-label="Close" onClick={onClose}>
              <X size={24} />
            </DrawerClose>
          )}
        </DrawerHeader>
        <DrawerBody $scrollable={scrollable}>{children}</DrawerBody>
        {footer ? <DrawerFooter>{footer}</DrawerFooter> : null}
      </DrawerPanel>
    </>
  );
}
